var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-table-empty-state',{attrs:{"md-label":_vm.label,"md-description":_vm.description}},[_c('img',{staticClass:"mt-5",attrs:{"src":require("@/assets/svg/undraw_empty_xct9.svg")}})])}
var staticRenderFns = []

export { render, staticRenderFns }